import { Box, Container, Divider, Grid, Grid2, Typography } from '@mui/material';
import './App.css';
import logo from './assets/newLogo.png'
import image from './assets/circles.png'
import footerImage from './assets/footerImage.png'
import InstagramIcon from '@mui/icons-material/Instagram';
import FacebookIcon from '@mui/icons-material/Facebook';
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import EmailIcon from '@mui/icons-material/Email';
function App() {
  const openInNewTab = (url) => {
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  return (
    <>
      <Box sx={{ background: 'linear-gradient(to bottom, #505050, black)' }}>
        <Container>
          <Grid2 container justifyContent={'space-between'} position='relative' alignItems={'center'} py='1.5em'>
            <Grid2 size={{ xs: 7, md: 4 }}>
              <img src={logo} alt='security' width='100%' />
            </Grid2>
            <Grid2 container alignItems={'center'}>
              <FacebookIcon
                sx={{ color: 'white', fontSize: '2rem', cursor: 'pointer' }}
                onClick={() => openInNewTab('https://www.facebook.com/profile.php?id=61567217819941')}
              />
              <InstagramIcon
                sx={{ color: 'white', fontSize: '2rem', cursor: 'pointer' }}
                onClick={() => openInNewTab('https://www.instagram.com/visiontech.mk/')}
              />
            </Grid2>
          </Grid2>
          <Grid2 container justifyContent={'center'} pt='4.5em' sx={{pb: {xs: '0.2em', md:'4.5em'}}}>
            <img src={image} alt='security' width='100%' />
          </Grid2>
        </Container>
            <Container sx={{ pt: '8em', position: 'relative' }}>
              <Grid2 container justifyContent="space-between" alignItems="center">
                <Box>
                  <Typography fontWeight="600" color={"white"} sx={{fontSize: {xs: '1.2rem', md: '1.8rem'}}}>
                    Контакт
                  </Typography>
                  <Divider
                    sx={{
                      width: { xs: '70%', sm: '30%', md: '70%' },
                      height: '2px',
                      mb: '1em',
                      backgroundColor: '#940000',
                    }}
                  />
                  <Grid2 container alignItems="center" spacing={2}>
                    <LocalPhoneIcon sx={{ color: '#940000' }} />
                    <Typography sx={{fontSize: {xs: '1.2rem', md: '1.8rem'}}} color="white">
                      070 66 66 09
                    </Typography>
                  </Grid2>
                  <Grid2 container alignItems="center" spacing={2}>
                    <LocalPhoneIcon sx={{ color: '#940000' }} />
                    <Typography sx={{fontSize: {xs: '1.2rem', md: '1.8rem'}}} color="white">
                      070 26 08 26
                    </Typography>
                  </Grid2>
                  <Grid2 container alignItems="center" spacing={2}>
                    <EmailIcon sx={{ color: '#940000' }} />
                    <Typography sx={{fontSize: {xs: '1.2rem', md: '1.8rem'}}} color="white">
                      contact@visontech.mk
                    </Typography>
                  </Grid2>
                </Box>
                {/* Align the image on the right */}
                <Box
                  sx={{
                    maxWidth: '480px',
                    width: '100%',
                  }}
                >
                  <img src={footerImage} alt="visiontech" width="100%" />
                </Box>
              </Grid2>
            </Container>
      </Box>
    </>
  );
}

export default App;
